import React from 'react';
import './../../styles/home/aboutus.css'; 


const AboutUs = () => {
  const aboutUsElements = [
    {
      id: 1,
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/noi-donostia-16e2f.appspot.com/o/Fotos%20Londres%20Loco%20polo%2FNaroa_Hotel%20Londres_1.jpg?alt=media&token=917f03bb-842c-4fe8-8428-a6d0f59fd294', 
      subtitle: 'Profesionalidad',
      description: 'En NOI, garantizamos brindarte un servicio profesional y dedicado en cada visita. Tu satisfacción es nuestra prioridad absoluta, por lo que nos esforzamos continuamente para superar tus expectativas. Confía en nosotros y realzaremos tu belleza natural.',
    },
    {
      id: 2,
      imageUrl: 'https://firebasestorage.googleapis.com/v0/b/noi-donostia-16e2f.appspot.com/o/Fotos%20Londres%20Loco%20polo%2FNaroa_Hotel%20Londres_18.jpg?alt=media&token=0f090420-7287-44e4-9408-57c3c976a9a0', 
      subtitle: 'Personalización',
      description: 'NOI se distingue por su capacidad para adaptarse a las necesidades individuales de cada cliente. Ofrecemos un enfoque personalizado en nuestros servicios, asegurándose de que cada persona reciba un tratamiento único y adecuado a sus preferencias y requerimientos.',
    },
  ];

  return (
    
    <div className="why-us-component">
        <h2>Belleza a domicilio</h2>
        <p className="why-us-presentation">Noi nace fruto de la velocidad de la vida actual, donde el tiempo es un recurso valioso. Nos dedicamos a brindar un servicio de cuidado estético a domicilio. Personalizado y directamente a tu puerta.</p>
        <div className="why-us">
        {aboutUsElements.map((element) => (
            <div key={element.id} className="why-us-item">
                <img src={element.imageUrl} alt={`Imagen ${element.id}`} />
                <p className="why-us-subtitle">{element.subtitle}</p>
                <p className="why-us-description">{element.description}</p>
            </div>
        ))}
        </div>
    </div>
  );
};

export default AboutUs;
